import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { TooltipProps, TooltipProviderProps } from "./types";

export const TooltipProvider: React.FC<TooltipProviderProps> = ({
  children,
  delayDuration = 300,
  skipDelayDuration = 300,
  disableHoverableContent = false,
}) => {
  return (
    <TooltipPrimitive.Provider
      delayDuration={delayDuration}
      skipDelayDuration={skipDelayDuration}
      disableHoverableContent={disableHoverableContent}
    >
      {children}
    </TooltipPrimitive.Provider>
  );
};

export const Tooltip: React.FC<TooltipProps> = ({
  children,
  content,
  side = "top",
  align = "center",
  sideOffset = 5,
  alignOffset = 0,
  maxWidth = "300px",
  className,
  contentClassName,
  delayDuration,
  disableHoverableContent,
  open,
  defaultOpen,
  onOpenChange,
  arrowClassName,
}) => {
  return (
    <TooltipPrimitive.Provider
      delayDuration={delayDuration || 300}
      skipDelayDuration={300}
      disableHoverableContent={disableHoverableContent || false}
    >
      <TooltipPrimitive.Root
        delayDuration={delayDuration}
        disableHoverableContent={disableHoverableContent}
        open={open}
        defaultOpen={defaultOpen}
        onOpenChange={onOpenChange}
      >
        <TooltipPrimitive.Trigger asChild className={className}>
          {children}
        </TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            side={side}
            align={align}
            sideOffset={sideOffset}
            alignOffset={alignOffset}
            className={`z-[9999999] rounded-[6px] bg-tooltip-bg dark:bg-tooltip-bg-dk backdrop-blur-[10px] px-[10px] py-[8px] font-normal text-pure-white dark:text-pure-white-dk ${
              contentClassName || "text-md"
            }`}
            style={{
              maxWidth:
                typeof maxWidth === "number" ? `${maxWidth}px` : maxWidth,
              wordBreak: "break-word",
              whiteSpace: "normal",
            }}
          >
            {content}
            <TooltipPrimitive.Arrow
              className={`fill-tooltip-bg dark:fill-tooltip-bg-dk ${arrowClassName}`}
              width={16}
              height={8}
            />
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
};
